// extracted by mini-css-extract-plugin
export var main = "index-module--main--ENKsD";
export var mainHeader = "index-module--mainHeader--Eb5JO";
export var bounceUp = "index-module--bounceUp--YkiNp";
export var decoration = "index-module--decoration--mM1YZ";
export var playVideo = "index-module--playVideo--DtSru";
export var videoContentWrapper = "index-module--videoContentWrapper--C5W6+";
export var contentWrapper = "index-module--contentWrapper--25Xre";
export var mainContent = "index-module--mainContent--PMtD5";
export var contentText = "index-module--contentText--rzivV";
export var civilizations = "index-module--civilizations--igY8D";
export var civilizationsTitle = "index-module--civilizationsTitle--rtr8Z";
export var civilizationsSubtitle = "index-module--civilizationsSubtitle--W-Sty";
export var arrowsP = "index-module--arrowsP--vsQs+";
export var arrowsG = "index-module--arrowsG--b1mHp";
export var tablet = "index-module--tablet--ELuy2";
export var mobile = "index-module--mobile--D5352";
export var desktop = "index-module--desktop--bFnFY";
export var animatedButton = "index-module--animatedButton--ZDX2E";
export var animationDescription = "index-module--animationDescription--MtuLu";
export var animateBottom = "index-module--animateBottom--nW93t";
export var animationTitleFirst = "index-module--animationTitleFirst--jRAXK";
export var animateLeft = "index-module--animateLeft--ZUUa1";
export var animationTitleSecond = "index-module--animationTitleSecond--tgA9q";
export var animateTop = "index-module--animateTop--2APfi";
export var animationButtonActive = "index-module--animationButtonActive--TIPZJ";
export var animatedArrow = "index-module--animatedArrow--Tcp1e";
export var opacityArrowFirst = "index-module--opacityArrowFirst--tkM92";
export var opacityArrowSecond = "index-module--opacityArrowSecond--XX9La";
export var soundIcon = "index-module--soundIcon--YFzmU";
export var videoWrapper = "index-module--videoWrapper--Ce7Rb";
export var videoPreview = "index-module--videoPreview--edvoo";
export var videoContainer = "index-module--videoContainer--8AlFV";
export var civilizationSlides = "index-module--civilizationSlides--MPjIk";
export var civilizationSlidesButtons = "index-module--civilizationSlides-buttons--VXqgf";
export var civilizationSlidesButton = "index-module--civilizationSlides-button--wYRCq";
export var civilizationSlidesButtonText = "index-module--civilizationSlides-button-text--5dnS2";
export var slide = "index-module--slide--UAURH";
export var slideImage = "index-module--slide-image--k81ln";
export var slideContent = "index-module--slide-content--aoAbv";
export var slideBorder = "index-module--slide-border--WVLFh";
export var slideTitle = "index-module--slide-title--BoMT2";
export var slideText = "index-module--slide-text--2tkz9";
export var buttonTextContainer = "index-module--button-text-container--fK01C";
export var slidesCounter = "index-module--slides-counter--nywHf";
export var slidesCounterImage = "index-module--slides-counter-image--LCnWK";
export var slidesCounterText = "index-module--slides-counter-text--y14Je";
export var slidesCounterActive = "index-module--slides-counter-active--yeEA9";
export var slidesCounterSlash = "index-module--slides-counter-slash--lx+vK";
export var slidesCounterLength = "index-module--slides-counter-length--CpMOH";
export var sliderArrows = "index-module--slider-arrows--CwsyR";
export var sliderArrowLeft = "index-module--slider-arrow-left--IXwgX";
export var sliderArrowRight = "index-module--slider-arrow-right--qI5cX";
export var slideBtnWrap = "index-module--slide-btn-wrap--0E9nR";